import { render, staticRenderFns } from "./NoveltySubscription.vue?vue&type=template&id=0c36a40d&lang=pug&"
import script from "./NoveltySubscription.vue?vue&type=script&lang=js&"
export * from "./NoveltySubscription.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports